"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.DateTime = void 0;
var component_fields_1 = require("@doordash/component-fields");
var design_language_1 = require("@doordash/design-language");
var React = __importStar(require("react"));
var utilities_1 = require("../DateTime/utilities");
var types_1 = require("./types");
exports.DateTime = function (_a) {
    var value = _a.value, size = _a.size, label = _a.label, onChange = _a.onChange, error = _a.error, description = _a.description;
    var defaultDate = utilities_1.isValidDate(value)
        ? utilities_1.getDateFromISODate(value)
        : '';
    var defaultTime = utilities_1.isValidDate(value)
        ? utilities_1.getTimeFromISODate(value)
        : { hour: '', minute: '', period: types_1.Periods.None };
    var _b = React.useState(defaultDate), dateValue = _b[0], setDateValue = _b[1];
    var _c = React.useState(defaultTime), timeValue = _c[0], setTimeValue = _c[1];
    var dateHandler = function (newDateValue) {
        setDateValue(newDateValue);
        var dateTime = utilities_1.getISODateFromDateTime(newDateValue, timeValue);
        onChange(dateTime);
    };
    var timeHandler = function (newTimeValue) {
        setTimeValue(newTimeValue);
        var dateTime = utilities_1.getISODateFromDateTime(dateValue, newTimeValue);
        onChange(dateTime);
    };
    return (React.createElement(design_language_1.InlineChildren, null,
        React.createElement(component_fields_1.DateField, { placeholder: 'MM/DD/YYYY', label: label, value: dateValue, onChange: dateHandler, error: error, size: size }),
        React.createElement(component_fields_1.TimeField, { label: ' ', description: description || '\u00a0', minuteInterval: component_fields_1.TimeField.MinuteIntervals.One, value: timeValue, onChange: timeHandler, error: error && ' ', size: size })));
};
